'use strict';

import { account } from '../../fundus/account';
import { companyState, CompanyState } from "../../services/sessionState/companyState";
import { CreditCard } from '../../service_ui/billing/cardUtils';
import { Invoice, payments } from "../../services/payments/payments";
import { notify } from "../../services/notify/notify";
import { logger } from "../../services/logging/loggingService";

const creditCardHtml = require('text!./addCreditCardModal.html');

type AddCreditCardScope  = {
    cvc: number;
    card: CreditCard;
    $close: (input: any) => void;
    $dismiss: () => void;
    expiry: string;
    number: number;
    newlyPurchasedPlan?: account.plans;
    updatePayment: (status: boolean, response: any) => any;
    error?: any;
};

class ExternalAddCreditCardModalController {
    $scope: ng.IScope & AddCreditCardScope;
    processing: boolean;
    errorOccurred: boolean;
    errorMessage: string;
    backDisabled: boolean;

    constructor($scope: ng.IScope & AddCreditCardScope) {
        this.$scope = $scope;
        this.errorOccurred = false;
        $scope.card = new CreditCard("updateCCForm");
        this.displayError($scope.error);

        $scope.$watch('error', (newVal: any) => {
            if (newVal === null) { return; }
            this.backDisabled = true;
            this.displayError(newVal);
        });
    }

    cardNotValid() {
        const form = angular.element('form[name="updateCCForm"]').scope() as ng.IScope & {
            number: number;
            expiry: string;
            cvc: number;
        };

        return !(
            !this.processing &&
            form.number &&
            form.expiry &&
            form.cvc
        );
    }

    clearError() {
        this.errorOccurred = false;
        this.errorMessage = '';
    }

    private displayError(error: any) {
        const errorMessage = <any>this.formatError(error);
        if (errorMessage) {
            this.errorOccurred = true;
            this.errorMessage = errorMessage;
        }
    }

    private formatError(error: any) {
        if (!error) { return null; }
        if (error.message) {
            return JSON.parse(error.message).message
                .replace(/error:/gi, '');
        }
    }
}
ExternalAddCreditCardModalController.$inject = ['$scope'];

export function externalCreditCardDirective() {
    return {
        restrict: 'E',
        scope: {
            newlyPurchasedPlan: "=",
            updatePayment: "=",
            back: "&",
            $dismiss: "&",
            error: "="
        },
        template: creditCardHtml,
        controller: ExternalAddCreditCardModalController,
        controllerAs: 'ctrl'
    };
}

export class AddCreditCardModalController extends ExternalAddCreditCardModalController {
    cancelling: boolean;
    companystate: CompanyState;
    delinquent: boolean;
    lastInvoice: Invoice;
    nextInvoice: Invoice;
    nocard: boolean;
    zombie: boolean;

    constructor($scope: ng.IScope & AddCreditCardScope) {
        super($scope);
        this.companystate = companyState;

        Promise.all([payments.get_customer(), payments.get_subscription()])
            .then(([customer, sub]) => {
                this.delinquent = customer.delinquent;
                if (sub) {
                    this.cancelling = sub.cancel_at_period_end;
                    if (customer.sources.data.length === 0) {
                        this.nocard = true;
                    } else {
                        if (this.cancelling) {
                            notify.error("Please reactivate your subscription before making other updates.");
                            $scope.$dismiss();
                        }
                    }
                    payments.get_upcoming_invoice().then((invoice: Invoice) => {
                        this.nextInvoice = invoice;
                    });
                } else {
                    this.zombie = true;
                }
            });

        payments.get_invoices(1).then((invoices: Invoice[]) => {
            this.lastInvoice = invoices[0];
        });

        $scope.updatePayment = (status: boolean, response: any) => this.updatePayment(status, response); // stripe forms require models/functions to be on scope not controller
    }

    updatePayment(status: boolean, response: any) {
        if (this.processing) {
            return;
        }
        this.processing = true;
        if (response.error) {
            notify.error("Invalid credit card. Please try again.");
            this.processing = false;
        } else {
            notify.success("Processing new credit card");
            let prom: Promise<any> = payments.update_payment(response);
            if (this.cancelling) {
                prom = prom.then(() => {
                    return payments.reactivateSub();
                });
            }
            else if (this.delinquent && !this.zombie) {
                prom = prom.then(() => {
                    return payments.pay_invoice();
                });
            }

            prom.then(() => {
                return payments.get_customer();
            }).then((cus) => {
                notify.success("Credit card updated");
                this.$scope.$close(cus);
            }).catch((err) => {
                logger.error(err);
                notify.error("Something went wrong. Please try again.");
                this.processing = false;
                this.$scope.$apply();
            });
        }
    }
}

AddCreditCardModalController.$inject = ['$scope'];



// WEBPACK FOOTER //
// ./_src/service_ui/billing/addCreditCardModal.ts